module.exports = __webpack_public_path__ + "static/380a4beb51d4a4b3bb531904a08741d06492a2c0a11d75995d12efcef3cbb334-1b38b04aad8b1a3875448d5551ece75b.png";